import {PRODUCTSSAC_REQUEST, PRODUCTSSAC_REQUEST_FAIL, PRODUCTSSAC_REQUEST_SUCCESS} from "../utils/ActionTypes";

const INITIAL_STATE = {
    data: [],
    isFetching: false,
    hasError: false,
    errorMessage: "",
    selected: {},
    total: 0,
    rowsPerPage: 15,
};

export default function (state = INITIAL_STATE, action) {
    
    switch (action.type) {
        case PRODUCTSSAC_REQUEST:
            return ({
                ...state,
                isFetching: true,
                hasError: false,
                data: []
            });
        case PRODUCTSSAC_REQUEST_SUCCESS :
            //console.log("total",action)
            return ({
                ...state,
                isFetching: false,
                hasError: false,
                data: action.payload.records,
                total: action.payload.total
            });
        case PRODUCTSSAC_REQUEST_FAIL:
            return ({
                ...state,
                isFetching: false,
                hasError: true,
                errorMessage: action.payload ? action.payload.response : "",
            });

        default :
            return state;

    }
}